import { Controller } from "@hotwired/stimulus"

// Landing-page demo question (static Cloudflare Pages export). The answers are
// plain links to the guest-exam entry on learn.* — this controller only adds
// the analytics beacon and a pressed state so double-taps don't double-navigate.
// It must NEVER preventDefault: the navigation is the conversion.
export default class extends Controller {
  static targets = ["answer"]
  // testId: which category's test the card belongs to (drv.ge has B / A / AM
  // tabs), so the readout can split demo answers by category.
  static values = { questionId: Number, testId: Number }

  answer(event) {
    if (this.answered) {
      event.preventDefault()
      return
    }
    this.answered = true

    // Freeze the card and mark the pick with the app's real selected-answer
    // style, so the transition into the practice page is visually seamless.
    this.answerTargets.forEach((el) => {
      el.classList.add("pointer-events-none")
      if (el !== event.currentTarget) el.classList.add("opacity-60")
    })
    event.currentTarget.classList.remove("answer-option--default")
    event.currentTarget.classList.add("answer-option--selected")

    if (typeof zaraz !== "undefined") {
      zaraz.track("Funnel: Demo Question Answered", {
        domain: window.location.hostname,
        locale: document.documentElement.lang || "it",
        question_id: this.questionIdValue,
        test_id: this.testIdValue,
        answer_id: Number(event.currentTarget.dataset.answerId),
        // What the settings switch above the card put on the link (null = untouched).
        auto_advance: new URL(event.currentTarget.href).searchParams.get("auto_advance")
      })
    }
  }
}
